import { LogEventType } from '@akin-home/amplify';
import { UpdateRecordLogEvent } from '@akin-home/logging';
import { postLogEvent, PostLogEventParams } from './postLogEvent';

type Params = Omit<PostLogEventParams<UpdateRecordLogEvent['data']>, 'type'>;

export const postUpdateRecordLogEvent = (params: Params) =>
  postLogEvent({
    ...params,
    type: LogEventType.UPDATE_RECORD,
  });
